import React from "react";
import Page from "components/Page";
import { Props } from "./ProjectCustomFields";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const ProjectCustomFields = lazyWithRetry(() =>
  import("./ProjectCustomFields")
);

export default (props: Props) => (
  <Page>
    <ProjectCustomFields {...props} />
  </Page>
);
